import { th } from 'vuetify/lib/locale'
import loginPage from './views/LoginPage-th'
import paymentGate from './views/PaymentGate-th'
import paymentResult from './views/PaymentResult-th'
import paymentList from './views/PaymentList-th'
import footer from './components/Footer-th'
import appBar from './components/AppBar-th'

export default {
    ...th,
    loginPage,
    paymentGate,
    paymentResult,
    footer,
    paymentList,
    appBar
}
